import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationsService } from '../../services/organizations.service';
import { PermissionsService } from '../../services/permissions.service';
import { Organization } from '../../models/organization.model';
import { MatCardModule } from '@angular/material/card';
import { RekbotListSmallComponent } from '../../rekbots/rekbot-list-small/rekbot-list-small.component';
import { RekbotSelectsService } from '../../services/rekbot-selects.service';
import { NotificationService } from '../../services/notification.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalConfirmActionComponent } from '../../modals/modal-confirm-action/modal-confirm-action.component';
import { MessagesService } from '../../services/messages.service';
import { coerceStringArray } from '@angular/cdk/coercion';

@Component({
  selector: 'app-edit-organization',
  imports: [
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    RekbotListSmallComponent,
    MatIconModule
  ],
  templateUrl: './edit-organization.component.html',
  styleUrl: './edit-organization.component.css'
})
export class EditOrganizationComponent implements OnInit {

  public dialogRef?: MatDialogRef<ModalConfirmActionComponent>;
  readonly dialog = inject(MatDialog);

  editForm: FormGroup = new FormGroup({
    id: new FormControl(""),
    name: new FormControl(''),
    address: new FormControl(''),
    nip: new FormControl(''),
  });

  currentOrganization: Organization = new Organization(0, '', '', '');

  organizationId: number = 0;

  selectedRekbotsIds: number[] = [];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public permissionsService: PermissionsService,
    public organizationsService: OrganizationsService,
    private rekbotSelects: RekbotSelectsService,
    private notificationService: NotificationService,
    public messagesService: MessagesService

  ) {
  }

  ngOnInit(): void {
    this.organizationId = this.route.snapshot.params['organizationId'];

    if (this.organizationId) {
      this.organizationsService.getOrganization(this.organizationId)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.currentOrganization = new Organization(response.id, response.name, response.address, response.nip);

            this.editForm.patchValue({
              id: this.currentOrganization.id,
              name: this.currentOrganization.name,
              address: this.currentOrganization.address,
              nip: this.currentOrganization.nip
            });
          },
          error: (error) => {
            console.log(error);
            if (error.status === 401) {
              this.router.navigate(['/login']);
            }
          }
        });
    }
  }

  onSubmit() {
    //console.log(this.editForm);
    //console.log("selectedRekbotsIds", this.selectedRekbotsIds);
    //console.log("rekbotSelects", this.rekbotSelects.getSelectedRekbotIds());

    if (this.editForm.valid) {
      this.organizationsService.updateOrganization(this.editForm.value, this.rekbotSelects.getSelectedRekbotIds())
        .subscribe({
          next: (response: any) => {
            //console.log(response);

            this.notificationService.pushNotification(
              `Organizacja została zaktualizowana`, 'info', 5000);
            //this.router.navigate(['/organizations']);
          },
          error: (error) => {
            console.log(error);
            if (error.status === 401) {
              this.router.navigate(['/login']);
            } else {
              this.notificationService.pushNotification(
                `Wystapił błąd w trakcie zapisu`, 'error', 5000);

            }
          }
        });
    }
  }


  deleteOrganization() {
    //if (confirm("Czy na pewno chcesz usunąć organizację?")) {
      this.organizationsService.destroyOrganization(this.currentOrganization.id)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.notificationService.pushNotification(
              `Organizacja została usunięta`, 'info', 5000);
            this.router.navigate(['/organizations-list']);
          },
          error: (error) => {
            console.log(error);
            if (error.status === 401) {
              this.router.navigate(['/login']);
            } else {
              this.notificationService.pushNotification(
                `Wystapił błąd w trakcie usuwania`, 'error', 5000);

            }
          }
        });
    //}
  }

  removeOrganization() {
    this.openDialog("Czy na pewno chcesz usunąć organizację " + this.currentOrganization.name + "?");
  }
  openDialog(message: string, title: string = "Potwierdzenie") {

    this.messagesService.setMessage(message);
    this.messagesService.setTitle(title);

    this.dialogRef = this.dialog.open(ModalConfirmActionComponent, {
    });

    this.dialogRef.afterClosed().subscribe(result => {

      console.log("Dialog closed", result);
      if (result) {
        this.deleteOrganization();
      }
      this.dialogRef = undefined;
    });
  }

}
